/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import isEmpty from 'lodash/isEmpty';

import { Placeholder, HeroImageUnavailable } from 'sarsaparilla';

import { Photo } from './GatewayV1Hero.types';

interface LayoutSmProps {
    image?: Photo;
    showUnavailableImage?: boolean;
}

export function LayoutSm({ image, showUnavailableImage = false }: LayoutSmProps) {
    if (showUnavailableImage) {
        return (
            <div className="gateway-v1-hero-layout sm">
                <HeroImageUnavailable hasOverlayCopy={false} />
            </div>
        );
    }

    // If we don't have an image
    if (isEmpty(image)) {
        return (
            <div className="gateway-v1-hero-layout sm">
                <Placeholder height="100%" />
            </div>
        );
    }

    const heroStyle = image?.url ? { backgroundImage: `url(${image.url})` } : undefined;

    return (
        <div className="gateway-v1-hero-layout sm">
            <div
                className="photo hero"
                style={heroStyle}
                role="img"
                aria-label={image.altText}
            />
        </div>
    );
}
